module.exports = __webpack_public_path__ + "static/img/General Purpose Silicone Rubber For Molding.a86d47d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/General Purpose Silicone Rubber For Molding.jpg
// module id = 3EU3
// module chunks = 1